import { render } from "./ReferralReviewSummary.vue?vue&type=template&id=137b898c&scoped=true"
import script from "./ReferralReviewSummary.vue?vue&type=script&lang=js"
export * from "./ReferralReviewSummary.vue?vue&type=script&lang=js"

import "./ReferralReviewSummary.vue?vue&type=style&index=0&id=137b898c&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-137b898c"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QIcon,QBanner});
